import { SvgIcon, Typography } from "@material-ui/core";
import { LocationOnOutlined, Business } from "@mui/icons-material";

import { useGetVmsSearchRightsQuery } from "@/api/elasticSearch/vmsSearchApi";
import { LiveUnitIcon } from "@/common/components/SVG/Svg";
import HealthDot from "@/common/components/streaming/HealthDot/HealthDot";
import { LiveUnitMetaLanding } from "@/utilities/types/liveunit";
import { SearchIndex } from "@/utilities/types/search";

import { useStyles } from "./UnitInfoBoxStyles";


export const LiveUnitInfoBox: React.FC<LiveUnitMetaLanding> = ({
    liveUnitName,
    liveUnitSerial,
    clientName,
    locationName,
    locationCity,
    locationState,
    locationStreet,
    locationZip,
    unitHealth,
}) => {
    const classes = useStyles();
    const { data: searchRightsData } = useGetVmsSearchRightsQuery({
        indices: [SearchIndex.LiveUnits, SearchIndex.ArchiveCabinets, SearchIndex.Clients],
    });

    return (
        <>
            <div className={classes.titleRow}>
                {unitHealth &&
                    <div className={classes.health}>
                        <HealthDot health={unitHealth} />
                    </div>
                }
                <Typography className={classes.title}>
                    {locationName}
                </Typography>
            </div>
            {(locationStreet || locationCity || locationState) &&
                <div className={classes.row}>
                    <LocationOnOutlined className={classes.icon} />
                    <div>
                        <Typography className={classes.infoText}>{locationStreet}</Typography>
                        <Typography className={classes.infoText}>
                            {locationCity && `${locationCity}, `}{locationState && `${locationState} `}{locationZip}
                        </Typography>
                    </div>
                </div>
            }
            {liveUnitName &&
                <div className={classes.row}>
                    <SvgIcon className={classes.icon}>
                        <LiveUnitIcon />
                    </SvgIcon>
                    <Typography className={classes.infoText}>
                        {liveUnitName}{liveUnitSerial && !liveUnitName.includes(liveUnitSerial) && `, ${liveUnitSerial}`}
                    </Typography>
                </div>
            }
            {searchRightsData && searchRightsData.data.is_multi_client && clientName &&
                <div className={classes.row}>
                    <Business className={classes.icon} />
                    <Typography className={classes.infoText}>{clientName}</Typography>
                </div>
            }
        </>
    );
};
